import { AppMonitoring } from './app-monitoring.model';

export abstract class MonitoringService implements AppMonitoring {
  abstract logPageView: () => void;

  abstract logEvent: (
    name: string,
    properties?: { [key: string]: any }
  ) => void;

  abstract logMetric: (
    name: string,
    average: number,
    properties?: { [key: string]: any }
  ) => void;

  logException(error: Error) {
    console.error(error);
  }

  abstract logTrace: (
    message: string,
    properties?: { [key: string]: any }
  ) => void;
}
